import React, { useEffect } from 'react'
import { Button, Box as Container, Icon, Textarea } from '@node-space/ui-components'
import { useMappedRoles } from 'hooks/useMappedRoles'

export interface TextAreaProps {
  disabled?: boolean
  isLoading?: boolean
  value: string
  name?: string
  placeHolder?: string
  testid?: string
  sendEmail: () => void
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
}

export const SendEmailArea = ({
  disabled,
  isLoading,
  value,
  name,
  testid,
  placeHolder,
  onChange,
  sendEmail,
}: TextAreaProps) => {
  const permissions = useMappedRoles().paymentSupport
  const isFieldDisabled = !permissions?.canEdit || disabled || isLoading

  useEffect(() => {
    if (!value) {
      // reset caseEmailsList manipulated height
      const caseEmailsList = document?.getElementById('caseEmailsList')
      caseEmailsList?.style && caseEmailsList?.style?.setProperty('height', `calc(100% - 151px)`)
    }
  }, [value])

  return (
    <Container width="full" paddingT={16}>
      <Textarea
        testId={testid}
        id="caseEmailInputArea"
        name={name}
        variant="chat"
        value={value}
        placeholder={placeHolder}
        disabled={isFieldDisabled}
        onChange={onChange}
        SendButton={
          <Button
            iconElement={<Icon name="PaperPlane" />}
            variant="ghost"
            loading={isLoading}
            noPadding
            onClick={sendEmail}
            disabled={isFieldDisabled || !value?.trim()}
          />
        }
      />
    </Container>
  )
}
